export { default } from './Renegociacao25Blog';
